import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {Mode} from "./mode.model";

interface ModeSlice {
  state: any;
  iranianModes: Mode[];
  foreignModes: Mode[];
}

const initialState: ModeSlice = { state: null, iranianModes: [], foreignModes: []};

export const modeSlice = createSlice({
  name: "mode",
  initialState,
  reducers: {
    setIranianMode: (state, action: PayloadAction<Mode[]>) => {
      state.iranianModes = action.payload;
    },
    setForeignMode: (state, action: PayloadAction<Mode[]>) => {
      state.foreignModes = action.payload;
    },
  },
});

export const {
  reducer: modeReducer,
  actions: modeActions,
} = modeSlice;
